// Module
var code = "<div> <p> <input type=\"checkbox\" class=\"filled-in\" ng-checked=\"$ctrl.item.Value == 'true'\" disabled=\"disabled\"/> <label>{{$ctrl.item.Label}}</label> </p> </div> ";
// Exports
export default code;